import './Surveycard.css'
import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { user_data, user_login_state, user_role, w_labels, langs, chosen_lang, redir, surveys } from '../RecoilState';
import Text from './Text'
import { Spin } from 'antd';
import { setCatchHandler } from 'workbox-routing';


const Surveycard = ({ value }) => {

    // console.log(value)

    const [userdata, setUserdata] = useRecoilState(user_data);
    const [show, setShow] = useState(false);
    const [redirect, setRedirect] = useRecoilState(redir);
    const [carddata, setCarddata] = useState(false);

    useEffect(() => { console.log(carddata) }, [])
    useEffect(() => { console.log(userdata.hobby) }, [])
    useEffect(() => { console.log(value) }, [])

    useEffect(() => {
        if ((value.bn).toLowerCase() === "উন্নতি") {
            setCarddata(false)
        } else {
            setCarddata(true)
        };
    }, []);

    useEffect(() => {
        if ((value.bn).toLowerCase() === "চাকরিপ্রার্থী") {
            setCarddata(false)
        } else {
            setCarddata(true)
        };
    }, []);

    useEffect(() => {
        if ((userdata.type).toLowerCase() === (value.en).toLowerCase()) {
            setShow(true);
            // console.log("✔ true");
        } else {
            setShow(false);
            // console.log("false");
        };
    }, []);

    const Enabled = () => {
        return (
            <>
                <div className="cursor-pointer" onClick={() => setRedirect("survey")}>
                    <div className="survey-card-container h-36">
                        <img className="p-4" src={require(`../assets/${value.sicon}`)} width="90" />
                        <Text style={"text text-bold"} value={value} />
                    </div>
                </div>
            </>
        )
    }

    const Disabled = () => {
        return (
            <>
                {/* <div className="cursor-not-allowed" >
                    <div className="disabled-survey-card-container h-36">
                        <img className="filter grayscale p-4" src={require(`../assets/${value.sicon}`)} width="90" />
                        <Text style={"text text-bold"} value={value} />
                    </div>
                </div> */}
            </>
        )
    }

    const Marked = () => {
        return (
            <>
                <div className="cursor-not-allowed">
                    <div className="marked-survey-card-container h-36">
                        <img className="filter sepia p-4" src={require(`../assets/${value.sicon}`)} width="90" />
                        <Text style={"text text-bold"} value={value} />
                    </div>
                </div>
            </>
        )
    }




    return (
        <>
            {carddata ?
                <>
                    {
                        ((value.en).toLowerCase() === "demo") ? null :
                            show ? <Enabled /> :
                                <Disabled />
                    }
                </>
                :
                // <Spin />
                null
            }
        </>
    )
}

export default Surveycard